import classNames from 'classnames';

import { InputType, InputVariant } from '../../types/enums';

import styles from './Input.module.scss';

interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
  id: string;
  value: string | number;
  setValue?: (val: string) => void;
  label?: string;
  type?: InputType;
  placeholder?: string;
  error?: string;
  icon?: string;
  helperText?: string;
  variant?: InputVariant;
  readonly?: boolean;
  autoComplete?: 'on' | 'off';
}

const Input = ({
  id,
  value,
  label,
  setValue,
  type = InputType.TEXT,
  placeholder = '',
  error = '',
  icon,
  helperText = '',
  variant = InputVariant.NORMAL,
  readonly = false,
  autoComplete = 'on',
  ...rest
}: InputProps) => {
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.inline]: variant === InputVariant.INLINE
      })}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <input
        {...rest}
        style={icon ? { backgroundImage: `url(${icon})` } : {}}
        className={`${styles.input} ${icon ? styles.icon : ''}`}
        value={value}
        onChange={(e) => setValue?.(e.target.value)}
        {...{ id, type, placeholder, autoComplete }}
        name={id}
        readOnly={readonly}
      />
      {helperText && <div className={styles.helperText}>{helperText}</div>}
      {error && (
        <div
          className={classNames(styles.errorText, {
            [styles.inlineError]: variant === InputVariant.INLINE
          })}>
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
